import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function post(data) {
  const response = await http.postData("/asesmen-kemoterapi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function put(id, data) {
  const response = await http.putData(`/asesmen-kemoterapi/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function getByReg(reg) {
  const response = await http.getData(`/register/${reg}/asesmen-kemoterapi`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

function print(id) {
  window.open(`${http.getAPI()}/asesmen-kemoterapi/${id}/pdf`, "_blank");
}

export default {
  post,
  put,
  getByReg,
  print,
};

